<template>
	<div class="banner" :style="{backgroundImage:'url('+dataimgs[0].src1+')'}">
		<el-row>
			<el-col :lg="4" :xl="4">
				<div class="hidden-md-and-down">&nbsp;</div>
			</el-col>
			<el-col :xs="24" :sm="24" :md="24" :lg="16" :xl="16">
				<div class="center">
					<div class="banner-overlay1">
						<h1>{{dataimgs[0].title}}</h1>
						<p v-for="c in dataimgs[0].content" :key='c.name'>{{c}}</p>
						<div class="try-btn-area">
							<el-button type="primary" class="hidden-md-and-down" @click="dialogVisible = true">{{dataimgs[0].btn}}</el-button>
							<el-button type="primary" size="small" class="hidden-lg-and-up" @click="dialogVisible = true">{{dataimgs[0].btn}}</el-button>
						</div>
					</div>
				</div>
				<el-dialog :title="dataimgs[0].platform" :visible.sync="dialogVisible" width="445px">
					<div style="display: flex;align-items: center; justify-content:center;"><a style="text-decoration: none; font-size:14px; "
						 href="http://wpa.qq.com/msgrd?v=3&amp;uin=2629198267&amp;site=qq&amp;menu=yes" target="_blank"><img src="@/assets/images/qq(2).png"
							 style="width: 35px">
							<p style="margin-left:10px ;color: #349CE3;display: initial;font-size:14px;">2629198267</p>
						</a></div>
					<div style="display: flex;align-items: center; justify-content:center; margin-top:20px;"><img alt="" src="@/assets/images/phone.png"
						 style="width: 29px;">
						<p style="margin-left:10px;color: #349CE3;font-size:14px;">021-54011298</p>
					</div>
				</el-dialog>
			</el-col>
			<el-col :lg="4" :xl="4">
				<div class="hidden-md-and-down">&nbsp;</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	export default {
		name: 'Banner',
		components: {},
		props: ['dataimgs'],
		data() {
			return {
				dialogVisible: false
			}
		},
		methods: {

		},

	}
</script>

<style>
	.banner {
		height: 627px;
		background-repeat: no-repeat;
		background-size: 100% 100%;
		overflow-y: hidden;
	}

	.banner .el-dialog__header {
		padding: 20px 20px 0px;
	}

	.banner .el-dialog__title {
		line-height: 22px;
		font-size: 16px;
		color: #303133;
		font-family: "microsoft yahei";
		text-align: left;
		display: block;
	}

	.banner .center {
		width: 100%;
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
	}

	.banner .banner-overlay1 {
		width: 570px;
		padding: 180px 30px 0;
		color: #FFFFFF;
		text-align: left;
	}

	.banner .banner-overlay1 .title {
		-webkit-transform: translateY(0px) !important;
		transform: translateY(0px) !important;
		opacity: 1 !important;
		font-size: 30px;
		font-family: MFYueHei_Noncommercial-Light;
		color: rgba(255, 255, 255, 1);
		/* line-height: 63px; */
		font-weight: lighter;
	}

	.banner-overlay1 h1 {
		color: #FFFFFF;
		font-size: 30px;
		transform: translateY(0px);
		line-height: 64px;
		transition: all 0.6s;
		margin-bottom: 15px;
		width: 100%;
	}

	.banner-overlay1 p {
		color: #FFFFFF;
		font-size: 16px;
		transform: translateY(0px);
		line-height: 30px;
		transition: all 0.6s;
		width: 100%;
	}

	.banner-overlay1 .try-btn-area {
		color: #FFFFFF;
		width: initial;
		text-align: left;
		font-size: 48px;
		line-height: 48px;
		margin-top: 30px;
	}

	@media(max-width:992px) {
		.banner {
			height: 198px;
			background-repeat: no-repeat;
			background-size: 100% 100%;
		}

		.banner .banner-overlay1 {
			padding: 70px 30px 0;
			color: #FFFFFF;
			text-align: left;
		}

		.banner .banner-overlay1 h1 {
			color: #FFFFFF;
			font-size: 18px;
			transform: translateY(0px);
			line-height: 24px;
			transition: all 0.6s;
			margin-bottom: 5px;
		}

		.banner .banner-overlay1 p {
			color: rgba(255, 255, 255, .5);
			font-size: 14px;
			transform: translateY(0px);
			line-height: 14px;
			transition: all 0.6s;
		}

		.banner .banner-overlay1 .try-btn-area {
			color: #FFFFFF;
			width: initial;
			text-align: left;
			font-size: 48px;
			line-height: 48px;
			margin-top: 10px;
		}

		.banner .banner-overlay1 .try-btn-area .el-button {
			type: small;
			margin-left: 0;
		}
	}
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/Banner.vue